$('.reset').click(function () {
    $sigdiv.jSignature("reset");
    $('[name=signature]').val('');
});

$('.submitSignature').click(function () {
    var datapair = $sigdiv.jSignature("getData","default");
    $('[name=signature]').val(datapair.replace(/^data\:image\/\w+\;base64\,/, ''));
    setTimeout(function () {
        $('#formSignature').submit();
    },100);
});

$('#formSignature').on('submit',function (e) {
    e.preventDefault();

    var data = $(this).serialize();

    if( $('input[name=terms]').val() == 'no' ){
        swal({
            text: "Debe aceptar las condiciones comerciales, dando click en el checkbox",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }

    if( $('[name=validate_signature]').val() == 'si' ){
        if( $('[name=signature]').val() == '' ){
            swal({
                text: "Debe digitar su firma",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        if( $('[name=signature]').val() == signatureValidation){
            swal({
                text: "Debe digitar su firma",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }
    }

    swal({
        text: "Estamos validando, espere un momento ...",
        icon: imageURL,
        button: false,
        closeOnClickOutside: false,
    });

    
    var formData = new FormData();
    formData.append('rut_file', $('#formSignature input[name=rut_file]')[0].files[0]);
    formData.append('camera_file', $('#formSignature input[name=camera_file]')[0].files[0]);
    formData.append('document_file', $('#formSignature input[name=document_file]')[0].files[0]);
    formData.append('signature', $('#formSignature input[name=signature]').val());

    //console.log(formData);
    //return false;
    $.ajax({
        url: https + "signatureRegister",
        method: "POST",
        data: formData,
        processData: false,
        contentType: false,
        success: function (data) {
            if ($.trim(data) == "1") {
                //$("#formSignature")[0].reset();
                swal.close();
                swal({
                    title: "",
                    text: "¡Firma enviada y guardada con exito!",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                })
                .then((willDelete) => {
                    if (willDelete) {
                        location.href = https + "thanks";
                    } else { 
                    }
                });
            }else {
                swal({
                    text: "" + data,
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

$sigdiv = $("#signature");
$sigdiv.jSignature({color:"#000000",lineWidth:0,'decor-color': 'transparent',});
var datapair = $sigdiv.jSignature("getData","default");
signatureValidation = datapair.replace(/^data\:image\/\w+\;base64\,/, '');